/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.25",
    versionName: "0.7.0-nightly.2026.9.25",
    versionChannel: "nightly",
    buildDate: "2026-09-25T00:16:23.844Z",
    commitHash: "76bdd47709bd9d30e5db7b3035d6bb913decf162",
};
